export default __webpack_public_path__ + "static/media/august2024-1.b83304c7.jpg";